import Image from 'next/image'

import { useTranslation } from '@/lang'
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle } from '@/shared/components/alert-dialog'
import { cn } from '@/shared/utils/class-name-utils'
import COLOR from '@/components/cell/designTokens/color'
import wechatQrImage from '@/assets/qr/wechat.png'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const WeChatModal = ({ open, onOpenChange }: Props) => {
  const { t } = useTranslation()

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className={cn('bg-[#f5f5f5] max-w-[400px] max-h-[90vh] overflow-y-auto')}>
        <AlertDialogHeader className="flex flex-row items-center justify-between space-y-0">
          <AlertDialogTitle className="text-left m-0 leading-none">
            {t('common.footer.sns.wechat.imgImgAlt')}
          </AlertDialogTitle>
          <button
            onClick={() => onOpenChange(false)}
            aria-label="Close"
            className="bg-transparent border-0 text-[32px] leading-none cursor-pointer p-0 w-8 h-8 flex items-center justify-center hover:opacity-70 shrink-0"
            style={{ color: COLOR.gray800 }}
          >
            ×
          </button>
        </AlertDialogHeader>
        <div className="flex justify-center items-center">
          <Image src={wechatQrImage} alt="WeChat QR Code" className="w-full h-auto rounded-lg" />
        </div>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default WeChatModal
